import * as Quill from 'quill'
const Link = Quill.import('formats/link')
const BlockEmbed = Quill.import('blots/block/embed')

const ATTRIBUTES = [
  'src',
]
class Audio extends BlockEmbed {

  static create (value) {
    let node = super.create(value)
    node.setAttribute('style', 'width: 40%;')
    node.setAttribute('controls', 'controls')
    if (value.src) {
      node.setAttribute('src', value.src)
    } else {
      node.setAttribute('src', value)
    }
    return node
  }

  static formats (domNode) {
    return ATTRIBUTES.reduce(function (formats, attribute) {
      if (domNode.hasAttribute(attribute)) {
        formats[attribute] = domNode.getAttribute(attribute)
      }
      return formats
    }, {})
  }

  static sanitize (url) {
    return Link.sanitize(url)
  }

  static value (domNode) {
    return domNode.getAttribute('src')
  }

  format (name, value) {
    if (ATTRIBUTES.indexOf(name) > -1) {
      if (value) {
        this.domNode.setAttribute(name, value)
      } else {
        this.domNode.removeAttribute(name)
      }
    } else {
      super.format(name, value)
    }
  }
}
Audio.blotName = 'audio'
Audio.className = 'ql-audio'
Audio.tagName = 'audio'


export default Audio



// WEBPACK FOOTER //
// ./src/plugins/Audio.js